/** ชนิดข้อมูลกลาง — ทุก deck ทุก mode ใช้ร่วมกัน */

export type DeckId = 'kana' | 'bushu' | 'kanji' | 'vocab'

/** `<deck>:<key>` — ห้ามเปลี่ยนหลังปล่อยใช้ ไม่งั้นความจำหาย */
export type CardId = string

export interface Card {
  id: CardId
  deck: DeckId
  /** ใช้กรอง — ["hiragana","a-row"] · ["d1"] · ["jlpt-n5"] */
  tags: string[]
  /** สิ่งที่แสดงบนหน้าการ์ด */
  front: string
  /** คำตอบหลัก */
  back: string
  /** คำตอบอื่นที่ยอมรับ — shi/si, tsu/tu */
  alts?: string[]
  /** ข้อมูลเฉพาะ deck: radical ที่ประกอบ, คันจิตัวอย่าง, pitch, เสียง */
  extra?: Record<string, unknown>
}

/** ตรงกับ State ของ ts-fsrs */
export const enum CardState {
  New = 0,
  Learning = 1,
  Review = 2,
  Relearning = 3,
}

export type Rating = 1 | 2 | 3 | 4 // Again | Hard | Good | Easy

/**
 * แยกจาก Card เด็ดขาด — แก้เนื้อหาการ์ดแล้วความจำไม่หาย
 * ทุก field เป็น primitive เพื่อให้ export/import เป็น JSON ได้ตรงๆ
 */
export interface Progress {
  cardId: CardId
  deck: DeckId
  /** epoch ms — ครบกำหนดทวนเมื่อไร */
  due: number
  stability: number
  difficulty: number
  elapsedDays: number
  scheduledDays: number
  /** ts-fsrs v5 ใช้นับ learning step ที่ผ่านมาแล้ว — ไม่เก็บ scheduling จะเพี้ยน */
  learningSteps: number
  reps: number
  lapses: number
  state: CardState
  /** epoch ms · 0 = ยังไม่เคยทวน */
  lastReview: number
  /**
   * เวลาตอบเฉลี่ย (ms) — ถูกแต่ช้าคือยังไม่ใช่ความจำอัตโนมัติ
   * ฝั่ง drill ใช้สัญญาณนี้มาตั้งแต่แรก · ฝั่ง SRS เพิ่งเก็บ จึงเป็น optional
   */
  avgMs?: number
  /** เผื่อ cloud sync ทีหลัง — last-write-wins ต่อ record */
  updatedAt: number
}

export interface ReviewLog {
  /** auto-increment ของ IndexedDB */
  id?: number
  cardId: CardId
  deck: DeckId
  ts: number
  rating: Rating
  /** เวลาที่ใช้ตอบ (ms) — ถูกแต่ช้า = ยังไม่แน่น */
  ms: number
  mode: string
  /** state ก่อนตอบ ใช้ตอน optimize FSRS ทีหลัง */
  stateBefore: CardState
}

/** สถิติแบบเบาสำหรับ kana — ไม่ผ่าน FSRS */
export interface DrillStat {
  cardId: CardId
  seen: number
  wrong: number
  /** ถูกติดกันกี่ครั้ง — ครบ 3 ออกจาก pool ชั่วคราว */
  streak: number
  /**
   * เวลาตอบเฉลี่ยแบบถ่วงน้ำหนักครั้งล่าสุด (ms) นับเฉพาะตอนตอบถูก
   * ตอบถูกแต่ช้ากว่าตัวอื่นมาก = ยังต้องนึก ไม่ใช่จำได้จริง
   */
  avgMs: number
  /** ครั้งล่าสุดที่ตอบผิด (epoch ms) · 0 = ไม่เคยผิด */
  lastWrongAt: number
  updatedAt: number
}
